/**
 * ค่า fallback ของหน้าจอ MeGen ที่ต้องมีชื่อ model/voice/style ตรง ๆ ในโค้ด
 *
 * ใช้เมื่อ list จาก backend ยังไม่โหลด หรือ scene เก่าไม่มีค่าเก็บไว้
 * (คนละเรื่องกับ image/video model ที่ list/default/ความสามารถ มาจาก catalog หลังบ้านเท่านั้น
 *  — ดู imageModelCatalog.ts / videoModelCatalog.ts)
 *
 * กติกา: ห้ามเขียนค่าเหล่านี้ซ้ำในไฟล์หน้าจอ ให้ import จากที่นี่ เพื่อให้ตอนอัปเกรดรุ่นแก้ที่เดียว
 *
 * ไฟล์นี้เก็บทั้ง "ค่า default" และ "list ตัวเลือกที่ค่า default ชี้เข้าไป"
 * (ASPECT_RATIO_OPTIONS) — ป้ายที่บอกว่าตัวไหนเป็น default ให้เติมตอน render ไม่ฝังใน label
 *
 * กติกา: ห้ามเพิ่มชื่อ image/video model กลับเข้ามาที่นี่ — ทั้งสองอย่างเป็นของหลังบ้าน
 * (GET /media/image-models, GET /media/video-models) เพิ่มที่นี่ = list เพี้ยนจากหลังบ้านอีกรอบ
 */

/** เสียงเริ่มต้นเมื่อ voiceList ยังไม่โหลด หรือ scene ไม่ได้ระบุ */
export const DEFAULT_VOICE_NAME = "Fenrir";

/** สไตล์ภาพเริ่มต้นเมื่อ mediaStyleList ยังไม่โหลด */
export const DEFAULT_IMAGE_STYLE = "CUTE_2D_CARTOON_IMAGE_STYLE";

/**
 * ตัวเลือกอัตราส่วนภาพของฟอร์ม direct script — **list คือแหล่งความจริง ค่า default ชี้มาที่ตัวแรก**
 * (อย่าเอา DEFAULT_ASPECT_RATIO ไปเป็น `value` ของ MenuItem ตรง ๆ ไม่งั้นวันที่เปลี่ยน default
 * จะได้ option ค่าซ้ำกันสองอันและป้ายไม่ตรงค่า)
 */
export const ASPECT_RATIO_OPTIONS = [
  { value: "16:9", label: "16:9 แนวนอน (Landscape)" },
  { value: "9:16", label: "9:16 แนวตั้ง (Portrait)" },
] as const;

/** อัตราส่วนภาพเริ่มต้นของฟอร์ม direct script */
export const DEFAULT_ASPECT_RATIO: string = ASPECT_RATIO_OPTIONS[0].value;

/** style ของ character ที่หมายถึง "ครึ่งตัว/หน้าตรง" (ค่าที่ backend รับ) */
export const CHARACTER_STYLE_PORTRAIT = "<portrait>";

